/**
 * Placeholder rendered by <InlineStyles /> in root.tsx; entry.server.tsx swaps it for the real
 * CSS while streaming (see inlineStyles.server.ts). The CSS itself cannot be imported in
 * root.tsx: that module is part of the client bundle too, and a `?inline` import there ships
 * the whole stylesheet inside root-*.js.
 */
export const INLINE_STYLES_MARKER = '/*__INLINE_STYLES__*/';
